import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash-es';
import { useSafeId } from 'site-modules/shared/hooks/use-safe-id';
import { fixTableCellValue } from 'site-modules/shared/utils/voiceover';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { Select } from 'site-modules/shared/components/select/select';

import './drivetrain-feature-field.scss';

export function DrivetrainFeatureField({ name, value, options, setTrimStyle }) {
  const id = useSafeId();

  return (
    <div className="drivetrain-feature-field" data-test={`feature ${name}`}>
      {options.length > 1 ? (
        <div className="drivetrain-select pos-r">
          <Select
            id={`features-drivetrain-${id}`}
            name="features-drivetrain"
            inputClassName="border-0 opacity-0 pos-a top-0 left-0 w-100 h-100"
            options={options}
            value={capitalize(value)}
            valueKey="driveTrain"
            labelKey="driveTrain"
            labelText="Drivetrain"
            isLabelHidden
            onChange={setTrimStyle}
            data-tracking-id="drivetrain_select"
          />
          <div className="feature-field-value pos-r select-overlay rounded bg-transparent text-primary-darker fw-normal">
            {value} <i className="icon-arrow-down3 size-10" aria-hidden />
          </div>
        </div>
      ) : (
        <ContentFragment classes="feature-field-value">{fixTableCellValue(value)}</ContentFragment>
      )}
    </div>
  );
}

DrivetrainFeatureField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      trim: PropTypes.string,
      driveTrain: PropTypes.string,
    })
  ).isRequired,
  setTrimStyle: PropTypes.func.isRequired,
};
